import { useMemo } from 'react';
import { AdvancedMultiSelectDropdown } from 'limetray-ui-kit';
import { userManagerConstants } from '../../../../constants/userManagerConstants';
import LtLabel from '../../../../components/LtLabel';

const { createRoleModal } = userManagerConstants;

/**
 * RoleBrandAccessSection
 *
 * Renders the "Brand Access" section for role create/edit.
 * Allows choosing a single brand from the fetched brands, or choosing "ALL" (Admin Access).
 */
function RoleBrandAccessSection({
  selectedBrandId,
  onChange,
  brands = [],
  showAdminButton = false,
  errors = {},
}) {
  const options = useMemo(() => {
    const list = brands.map((b) => ({
      id: String(b.brandId),
      label: b.brandName,
    }));
    if (showAdminButton) {
      list.unshift({ id: 'ALL', label: createRoleModal.sectionTitles.brandAccess.allBrandsLabel });
    }
    return list;
  }, [brands, showAdminButton]);

  const defaultSelected = selectedBrandId ? [String(selectedBrandId)] : [];

  const handleSelectBrand = (selectedItems) => {
    const value = Array.isArray(selectedItems) ? selectedItems[0] : selectedItems;
    onChange(value?.id || value || '');
  };

  const selectedBrandObj = options.find((o) => String(o.id) === String(selectedBrandId));

  return (
    <div className="inputGrid">
      <div className="row">
        <div className="modal-form-field">
          <LtLabel required>{createRoleModal.sectionTitles.brandAccess.inner}</LtLabel>
          <div
            className={`modal-role-dropdown ${!selectedBrandId ? 'is-placeholder' : ''}`}
            data-error={!!errors.brandId}
          >
            <AdvancedMultiSelectDropdown
              options={options}
              defaultSelectedItems={defaultSelected}
              isMultiSelect={false}
              isCollapsible={false}
              isSearchable={true}
              placeholder={createRoleModal.sectionTitles.brandAccess.placeholder}
              searchPlaceholder={createRoleModal.sectionTitles.brandAccess.searchPlaceholder}
              onSelect={handleSelectBrand}
              selectedBgColor="#e8f5e9"
              hoverBgColor="#f0f4f8"
              borderRadius="8px"
              showSelectAll={false}
              removeBorderBetweenItems
            />
          </div>
          {errors.brandId && (
            <span className="modal-field-error">{errors.brandId}</span>
          )}
        </div>
      </div>

      {selectedBrandObj && (
        <div className="selected-role-details-container">
          <div className="title">{createRoleModal.sectionTitles.brandAccess.detailsTitle}</div>
          <div className="details-grid brand-details-grid">
            <div className="detail-item">
              <span className="label">{createRoleModal.sectionTitles.brandAccess.labels.brandName}</span>
              <span className="value">{selectedBrandObj.label}</span>
            </div>
            <div className="detail-item">
              <span className="label">{createRoleModal.sectionTitles.brandAccess.labels.brandId}</span>
              <span className="value">{selectedBrandId}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RoleBrandAccessSection;
